// TODO: Move into MergeDialog file once it moves to TypeScript.
import { DocumentsForSave } from '@app/services';

export enum MergeDialogType {
  merge = 'merge',
  pull = 'pull',
  save = 'save'
};

export type MergeDialogProps = (
  DocumentsForSave
  & {
    /** Commit message to start with @default ''. */
    defaultCommitMessage?: string,
    /** Version number that will be created by the merge @default current version + 1 patch. */
    newVersionNumber?: string | null,
    /** Function to call once the save is complete (whether it was cancelled or not) @default noop. */
    onComplete?: () => void,
    /** Type of merge that is happening @default MergeDialogType.save. */
    type: MergeDialogType;
  }
);
